import React from "react";
import { Button, Flex, Typography } from "@payping/web-components";
import { useAppTranslation } from "@/utils/useAppTranslation";
import { useNavigate } from "react-router-dom";
import { DashboardRoutes } from "@/router/constant";

interface PendingReviewStateProps {
  onViewDetails?: () => void;
}

const PendingReviewState: React.FC<PendingReviewStateProps> = ({ onViewDetails }) => {
  const { t } = useAppTranslation();
  const navigate = useNavigate();

  const handleViewDetails = () => {
    if (onViewDetails) {
      onViewDetails();
    } else {
      navigate(DashboardRoutes.settings.bank.edit.url);
    }
  };

  return (
    <Flex
      className="tw-bg-white tw-my-8 tw-w-full tw-rounded-lg tw-border tw-border-solid tw-p-4"
      style={{ borderColor: "#D9D9D9" }}
    >
      <div className="tw-mb-6 tw-flex tw-justify-center">
        <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M40.0001 42.8125C36.7032 42.8125 33.6016 44.0937 31.2735 46.4297C30.1224 47.572 29.2098 48.9317 28.5889 50.4298C27.9679 51.928 27.6509 53.5346 27.6563 55.1562V65.625H52.3439V55.1562C52.3439 51.8594 51.0626 48.7578 48.7267 46.4297C47.5844 45.2786 46.2246 44.366 44.7265 43.7451C43.2284 43.1241 41.6218 42.8071 40.0001 42.8125V42.8125ZM27.6563 24.8438C27.6563 28.1406 28.9376 31.2422 31.2735 33.5703C33.6016 35.9063 36.7032 37.1875 40.0001 37.1875C43.297 37.1875 46.3986 35.9063 48.7267 33.5703C51.0626 31.2422 52.3439 28.1406 52.3439 24.8438V14.375H27.6563V24.8438Z"
            fill="#FAF6EE"
          />
          <path
            d="M57.9688 24.8438V14.375H64.6875C65.0313 14.375 65.3125 14.0938 65.3125 13.75V9.375C65.3125 9.03125 65.0313 8.75 64.6875 8.75H15.3125C14.9687 8.75 14.6875 9.03125 14.6875 9.375V13.75C14.6875 14.0938 14.9687 14.375 15.3125 14.375H22.0312V24.8438C22.0312 31.2109 25.3437 36.8125 30.3437 40C25.3437 43.1875 22.0312 48.7891 22.0312 55.1562V65.625H15.3125C14.9687 65.625 14.6875 65.9062 14.6875 66.25V70.625C14.6875 70.9688 14.9687 71.25 15.3125 71.25H64.6875C65.0313 71.25 65.3125 70.9688 65.3125 70.625V66.25C65.3125 65.9062 65.0313 65.625 64.6875 65.625H57.9688V55.1562C57.9688 48.7891 54.6562 43.1875 49.6562 40C54.6562 36.8125 57.9688 31.2109 57.9688 24.8438ZM52.3438 55.1562V65.625H27.6562V55.1562C27.6562 51.8594 28.9375 48.7578 31.2734 46.4297C33.6016 44.0937 36.7031 42.8125 40 42.8125C43.2969 42.8125 46.3984 44.0937 48.7266 46.4297C51.0625 48.7578 52.3438 51.8594 52.3438 55.1562ZM52.3438 24.8438C52.3438 28.1406 51.0625 31.2422 48.7266 33.5703C46.3984 35.9063 43.2969 37.1875 40 37.1875C36.7031 37.1875 33.6016 35.9063 31.2734 33.5703C30.1223 32.428 29.2098 31.0683 28.5888 29.5702C27.9678 28.072 27.6508 26.4654 27.6562 24.8438V14.375H52.3438V24.8438Z"
            fill="#F1AF0E"
          />
        </svg>
      </div>
      <Flex vertical align="start" gap="8px" className="tw-w-full tw-text-right">
        <Typography.Title level={4} className="!tw-mb-0 tw-text-right" style={{ color: "#000000E0" }}>
          {t("profile.bank.pendingReviewTitle")}
        </Typography.Title>

        <Typography.Text className="tw-mb-0 tw-block tw-text-right" style={{ color: "#00000080" }}>
          {t("profile.bank.pendingReviewDescription")}
        </Typography.Text>

        <Button type="link" onClick={handleViewDetails} className="!tw-text-blue-600 tw-mt-1 tw-self-end">
          {t("profile.bank.viewAccountDetails")}
        </Button>
      </Flex>
    </Flex>
  );
};

export default PendingReviewState;
